const loadImage = file => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file)
  const image = new Image()
  image.onload = () => {
    URL.revokeObjectURL(url)
    resolve(image)
  }
  image.onerror = () => {
    URL.revokeObjectURL(url)
    reject(new Error('unreadable'))
  }
  image.src = url
})

const canvasToBlob = (canvas, type, quality) => new Promise((resolve, reject) => {
  canvas.toBlob(blob => (blob ? resolve(blob) : reject(new Error('unencodable'))), type, quality)
})

export default async function normalizeImage(file, {
  maxSide = 1600,
  quality = 0.85,
  background = '#0b0f14',
  name = 'imagen.jpg',
} = {}) {
  const image = await loadImage(file)
  const sourceWidth = image.naturalWidth
  const sourceHeight = image.naturalHeight
  const scale = Math.min(1, maxSide / sourceWidth, maxSide / sourceHeight)
  const width = Math.round(sourceWidth * scale)
  const height = Math.round(sourceHeight * scale)

  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const context = canvas.getContext('2d')
  context.fillStyle = background
  context.fillRect(0, 0, width, height)
  context.imageSmoothingQuality = 'high'
  context.drawImage(image, 0, 0, width, height)

  const blob = await canvasToBlob(canvas, 'image/jpeg', quality)
  return {
    file: new File([blob], name, { type: 'image/jpeg' }),
    width,
    height,
    sourceWidth,
    sourceHeight,
  }
}
